import Agent from './agent'

const agent = new Agent()

export const translationService = {
  get: () => agent.get(`/translation`),
  update: (data) => agent.post(`/translation`, { data }),
}
